import { District } from "./district";

export class City {
    refNo : number;
    cityName : string;
    district:District;
    districtCode: number;

    //For import
    districtName: string;
}
